<template>
  <div>
    <h1>About Us</h1>
    <p>This is the about page.</p>
  </div>
</template>
